import React, { useState, useEffect, useContext, useRef } from 'react';
import { useCookies } from 'react-cookie';
import '../App.css';
import '../splashpage.css';
import axios from 'axios';
import Banner from './Banner'
import { GlobleContext } from './utils';
import Owl from './Owl';
import Swal from "sweetalert2";

const Splash = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '/';
    const productImgUrl = process.env.REACT_APP_Product_Images_URL;
    const aboutUsImgUrl = process.env.REACT_APP_AboutUs;
    const [productItemData, setproductItemData] = useState([]);
    const { getProfileData, profileData, getAboutUsData, aboutUsData } = useContext(GlobleContext)
    const [bannerData, SetBanner] = useState([]);
    const [vskCookies, setvskCookies, removeCookie] = useCookies(['vsk_Cookie']);
    const [isExpanded, setIsExpanded] = useState(false);
    const maxIndex = 5;

    const [isSubmit, setIsSubmit] = useState(false);
    const fileInputRef = useRef(null);

    const [validMail, setValidMail] = useState(false);
    const [formData, setFormData] = useState({
        UserName: {
            textValue: "",
            required: true,
        },
        PhoneNumber: {
            textValue: "",
            required: true,
            valid: false,
        },
        EmailID: {
            textValue: "",
            required: false,
        },
        CompanyName: {
            textValue: "",
            required: false,
        },
        TotalExperience: {
            textValue: "",
            required: false,
        },
        Message: {
            textValue: "",
            required: true,
        },
        Atachment: {
            textValue: "",
            valid: true,
            required: false,
        },
    });

    useEffect(() => {
        document.body.className = 'header-sticky page-template  page-homepage  home-header-v2 blog-classic topbar-v1 footer-v1  hide-topbar-mobile';
        getBanner();
        getAboutUsData();
        getProfileData();
        getProductItemData();
    }, []);

    const handleMenuClick = (ProductCategoryID) => {
        // Save data in the cookie
        removeCookie('PCID')
        setvskCookies('PCID', ProductCategoryID);
    };

    const formatImportExportCode = (code) => {
        if (code === null || code === undefined) {
            return 'No Code';
        }

        const visibleChars = code.substring(0, 5);
        const maskedChars = '*'.repeat(Math.max(0, code.length - 5));

        return `${visibleChars}${maskedChars}`;
    };

    const getBanner = async () => {
        const response = await axios.post(`${baseUrl}Banner/GetBanner`);
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                SetBanner(response.data.data);
            }
        }
    };

    const getProductItemData = async () => {
        const response = await axios.post(`${baseUrl}OurProduct/getProductDetail`, { PaginationID: "0", PageLength: "6" });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                setproductItemData(response.data.data);
            }
        }
    };

    const arrWhyUs = aboutUsData.find(item => item.Type === "Why Us");
    // console.log("jhjdhsjdshdjsds", arrWhyUs);
    const arrProductPortfolio = aboutUsData.find(item => item.Type === "Product Portfolio");
    const arrOurTeam = aboutUsData.find(item => item.Type === "Our Team");

    const toggleReadMore = () => {
        setIsExpanded(!isExpanded);
    };

    const handleInputChange = (e) => {
        let lastInputString = e.target.value[e.target.value.length - 1];
        console.log(lastInputString);
        if (e.target.name == "PhoneNumber") {
            if (
                e.target.value == "" ||
                (lastInputString.charCodeAt() >= 48 &&
                    lastInputString.charCodeAt() <= 57)
            ) {
                setFormData({
                    ...formData,
                    [e.target.name]: {
                        ...formData[e.target.name],
                        textValue: e.target.value,
                        valid: e.target.value.length === 10 ? true : false,
                    },
                });
            } else {
                return;
            }
            return;
        }
        if (e.target.name === "EmailID") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(e.target.value)) {
                setValidMail(true);
            } else {
                setValidMail(false);
            }
        }
        setFormData({
            ...formData,
            [e.target.name]: {
                ...formData[e.target.name],
                textValue: e.target.value,
            },
        });
    };
    const handleFileChange = (e) => {
        console.log(e.target.files[0], "e.target.value");

        if (
            ["jpg", "png", "jpeg", "pdf", "PDF"].includes(
                e.target.value.split(".")[e.target.value.split(".").length - 1]
            ) ||
            e.target.value === ""
        ) {
            setFormData({
                ...formData,
                [e.target.name]: {
                    ...formData[e.target.name],
                    textValue: e.target.files[0],
                    valid: true,
                },
            });
        } else {
            setFormData({
                ...formData,
                [e.target.name]: {
                    ...formData[e.target.name],
                    textValue: "",
                    valid: false,
                },
            });
        }
    };

    const handleEnquirySubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        console.log(formData, "formData");
        let validForm = true;
        for (let key in formData) {
            if (formData[key].required) {
                if (!formData[key].textValue) {
                    validForm = false;
                }

                if (!validForm) {
                    return;
                }
            }
        }

        if (formData.PhoneNumber.textValue.length !== 10) {
            setFormData((prev) => {
                let updatedValue = {
                    ...prev,
                    PhoneNumber: {
                        ...prev.PhoneNumber,
                        valid: false,
                    },
                };
                return updatedValue;
            });
            validForm = false;

            if (validForm == false) {
                return;
            }
        }
        if (formData.Atachment?.valid == false) {
            return;
        }

        if (!validMail && formData.EmailID.textValue.length) {
            return;
        }
        // if (!validMail) {
        //     return;
        // }
        if (formData.UserName.textValue.length <= 2) {
            return;
        }
        console.log(formData);

        const form = new FormData();
        form.append("Name", formData?.UserName?.textValue);
        form.append("MobileNo", formData?.PhoneNumber?.textValue);
        form.append("EmailID", formData?.EmailID?.textValue);
        form.append("CompanyName", formData?.CompanyName?.textValue);
        form.append("BusinessExperience", formData?.TotalExperience?.textValue);
        form.append("Description", formData?.Message?.textValue);
        form.append("Attachment", formData?.Atachment?.textValue);

        const config = { headers: { "Content-Type": "multipart/form-data" } };
        axios.post(
            `${baseUrl}DistributorEnquiry/SetDistributorEnquiry`,
            form,
            config
        ).then((result) => {
            console.log(result, "result");
            if (result.data.status === 1) {
                Swal.fire({
                    title: "Submited Successfully",
                    icon: "success",
                    timer: 1500,
                });
                setFormData({
                    UserName: {
                        textValue: "",
                        required: true,
                    },
                    PhoneNumber: {
                        textValue: "",
                        required: true,
                        valid: false,
                    },
                    EmailID: {
                        textValue: "",
                        required: false,
                    },
                    CompanyName: {
                        textValue: "",
                        required: false,
                    },
                    TotalExperience: {
                        textValue: "",
                        required: false,
                    },
                    Message: {
                        textValue: "",
                        required: true,
                    },
                    Atachment: {
                        textValue: "",
                        valid: true,
                        required: false,
                    },
                });
                handleClearButtonClick()
                setValidMail(true);
                setIsSubmit(false);
            }
        })
    };
    const handleClearButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <>
            <div id="content" className="site-content">
                <div className="slide-container">
                    <Banner dynamicImages={bannerData}></Banner>
                </div>

                <div className="whoandchoose-1 secpadd">
                    <div className="container">
                        {profileData &&
                            <div className="row service-list">
                                <div className="col-sm-6">
                                    <div className="fp-section-title clearfix  ">
                                        <h2>Profile</h2>
                                    </div>

                                    <div className="wwrimg margbtm20 profileimgdiv"><img className='profileimg' src={(profileData.Image == null ? process.env.REACT_APP_Profile_URL + 'Profile.png' : process.env.REACT_APP_Profile_URL + profileData.Image)} alt="image" /></div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="fp-section-title clearfix">
                                        <h2>Factsheet</h2>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="fa fa-handshake-o"></i></span>
                                                <h4 className='font15'>Nature of Business</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{profileData.NatureofBusiness}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="fa fa-users"></i></span>
                                                <h4 className='font15'>Total Number of Employees</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{profileData.NumberofEmployees}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="fa fa-building-o"></i></span>
                                                <h4 className='font15'>Year of Establishment</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{profileData.YearofEstablishment}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="fa fa-balance-scale"></i></span>
                                                <h4 className='font15'>Legal Status of Firm</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{profileData.LegalStatusofFirm}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="fa fa-line-chart"></i></span>
                                                <h4 className='font15'>Annual Turnover</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{profileData.AnnualTurnover}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="factory-internet"></i></span>
                                                <h4 className='font15'>Import Export Code (IEC)</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{
                                                        formatImportExportCode(profileData.ImportExportCode)}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=" fp-icon-box-3 icon-center dark-version">
                                                <span className="fp-icon"><i className="fa fa-file-text-o"></i></span>
                                                <h4 className='font15'>GST No.</h4>
                                                <div className="sub-title"></div>
                                                <div className="desc">
                                                    <p className='boldcss'>{profileData.GSTNo}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <p className='text-justify ellipsiscss'>{profileData.Description}</p>
                                    <div className='text-right'>
                                        <a href="/Profile" className="fp-btn-2nd readmore">Read More</a>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div className="project-style1 blackbg fp-service-2 secpadd" style={{ backgroundImage: 'url(images/bg/dark-parallax.jpg)', marginTop: '30px' }}>
                    <div className="container">
                        <div className="fp-latest-project style-1 service-list">
                            <h2>Our Products</h2>
                            <div className="list-project row">
                                {productItemData &&
                                    productItemData.map((item, index) => (

                                        // console.log("asdadaddadadad", item)
                                        index <= maxIndex ? (
                                            <div key={index} className="col-md-4 col-sm-6 col-xs-6">
                                                <div className="item-service ">
                                                    <div className="entry-thumbnail">
                                                        {item.ImageDetail &&
                                                            <a><img src={productImgUrl + item.ImageDetail[0].Image} style={{ height: '300px', width: '100%' }} alt="" /></a>
                                                        }
                                                    </div>
                                                    <div className="service-content">
                                                        <div className="overlay bbgo6"></div>
                                                        <h2 className="entry-title ourProductTitle">
                                                            <a className='ourProductTitleacss'>{item.ProductName}</a></h2>
                                                        <p className='ellipsiscss_3' dangerouslySetInnerHTML={{ __html: item.Description }}></p>
                                                        <a href={`/Product/${item.ProductCategory.replace(/\s+/g, '_')}`} className="readmore" onClick={() => handleMenuClick(item.ProductCategoryID)}>Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>

                {arrWhyUs &&
                    <div className="latestnews-1 secpadd">
                        <div className="container">
                            <div className="fp-section-title clearfix  ">
                                <h2>{arrWhyUs.Title}</h2>
                            </div>
                            <div className="row fp-latest-post">
                                <div className="col-md-7 col-sm-6 col-xs-6 item-latest-post ">
                                    <div className="entry-content text-justify"
                                        dangerouslySetInnerHTML={{ __html: isExpanded ? arrWhyUs.Description : `${arrWhyUs.Description.slice(0, 550)}...` }}>
                                        {/* {isExpanded ? arrWhyUs.Description : `${arrWhyUs.Description.slice(0, 100)}...`} */}
                                    </div>
                                    <div className='text-right'>
                                        <button className='fp-btn-2nd' onClick={toggleReadMore}>
                                            {isExpanded ? 'Read Less' : 'Read More'}
                                        </button></div>
                                </div>
                                <div className="col-md-5 col-sm-6 col-xs-6 item-latest-post ">
                                    <div className="entry-thumbnail">
                                        <img src={aboutUsImgUrl + arrWhyUs.Image} alt="image" style={{ width: '100%', height: '300px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                <div className="testimonial-1 paralex secpadd70" style={{ backgroundImage: 'url(images/bg/testi-hp1-parallax.jpg)' }}>
                    <div className="container">
                        <div className="fp-testimonials ">
                            <i className="factory-text"></i>
                            <h3>Testimonial</h3>
                            <div id="testimonial-slider1" className="testi-list">
                                <Owl></Owl>
                            </div>
                        </div>
                    </div>
                </div>

                {arrProductPortfolio &&
                    <div className="latestnews-1 secpadd">
                        <div className="container">
                            <div className="fp-section-title clearfix  ">
                                <h2>{arrProductPortfolio.Title}</h2>
                            </div>
                            <div className="row fp-latest-post">
                                <div className="col-md-5 col-sm-6 col-xs-6 item-latest-post ">
                                    <div className="entry-thumbnail">
                                        <img src={aboutUsImgUrl + arrProductPortfolio.Image} alt="image" style={{ width: '100%', height: '300px' }} />
                                    </div>
                                </div>
                                <div className="col-md-7 col-sm-6 col-xs-6 item-latest-post ">
                                    <div className="entry-content text-justify"
                                        dangerouslySetInnerHTML={{ __html: isExpanded ? arrProductPortfolio.Description : `${arrProductPortfolio.Description.slice(0, 600)}...` }}>
                                        {/* {isExpanded ? arrProductPortfolio.Description : `${arrProductPortfolio.Description.slice(0, 100)}...`} */}
                                    </div>
                                    <div className='text-right'>
                                        <button className='fp-btn-2nd' onClick={toggleReadMore}>
                                            {isExpanded ? 'Read Less' : 'Read More'}
                                        </button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="requst-quote1 bgimage secpadd mb-20" style={{ background: '#264766' }}>
                    <div className="container pad10">
                        <div className="row">
                            <div className="fp-section-title clearfix light-skin col-md-12">
                                <h2 style={{ color: '#fff', background: '#264766' }}>DISTRIBUTER ENQUIRY</h2>
                            </div>
                            <div className="col-md-12 fp-form fp-form-3">
                                <form onSubmit={handleEnquirySubmit} method="post" id="contact-form">
                                    <div className="row">

                                        <div className="col-lg-12">
                                            <div className="col-sm-4">
                                                <div className="form-group field">
                                                    <input
                                                        name="UserName"
                                                        value={formData.UserName.textValue}
                                                        onChange={handleInputChange}
                                                        placeholder="Your Name"
                                                        type="text"
                                                    />
                                                    {isSubmit &&
                                                        formData.UserName.textValue.length <= 2 && (
                                                            <span style={{ color: "red" }}>
                                                                Please Enter Name
                                                            </span>
                                                        )}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group field">
                                                    <input
                                                        name="PhoneNumber"
                                                        maxLength={10}
                                                        value={formData.PhoneNumber.textValue}
                                                        onChange={handleInputChange}
                                                        placeholder="Phone"
                                                        type="text"
                                                    />
                                                    {isSubmit && !formData.PhoneNumber.valid && (
                                                        <span style={{ color: "red" }}>
                                                            Please Enter Phone Number
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group field">
                                                    <input
                                                        name="EmailID"
                                                        value={formData.EmailID.textValue}
                                                        onChange={handleInputChange}
                                                        placeholder="Your Email"
                                                        type="text"
                                                    />
                                                    {isSubmit && (!validMail && (formData.EmailID.textValue.length != 0 && formData.EmailID.textValue.length > 0)) && (
                                                        <span style={{ color: "red" }}>
                                                            Please Enter Valid Email
                                                        </span>
                                                    )}
                                                    {/* {isSubmit && (!validMail || !formData.EmailID.textValue) && (
                                                    <span style={{ color: "red" }}>
                                                        Please Enter Valid Email
                                                    </span>
                                                )} */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                        <div className="col-sm-4">
                                            <div className="form-group field">
                                                <input
                                                    name="CompanyName"
                                                    value={formData.CompanyName.textValue}
                                                    onChange={handleInputChange}
                                                    placeholder="Your Company Name"
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group field">
                                                <input
                                                    name="TotalExperience"
                                                    value={formData.TotalExperience.textValue}
                                                    onChange={handleInputChange}
                                                    placeholder="Your Total Experience"
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <input
                                                    ref={fileInputRef}
                                                    type="file"
                                                    name="Atachment"
                                                    accept="image/jpeg, image/png, image/jpg , .pdf , .PDF"
                                                    onChange={handleFileChange}
                                                />
                                                {!formData.Atachment.valid && (
                                                    <span style={{ color: "red" }}>
                                                        Please Enter Valid File
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        </div>

                                        <div className="col-lg-12">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <textarea
                                                    name="Message"
                                                    value={formData.Message.textValue}
                                                    onChange={handleInputChange}
                                                    placeholder="Message"
                                                    maxLength={150}
                                                />
                                                {isSubmit && !formData.Message.textValue.length && (
                                                    <span style={{ color: "red" }}>
                                                        Please Enter Your Requirement
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        </div>

                                        <div className="col-lg-12">
                                        <div className="col-sm-2 submit text-center paddtop30">
                                            <input
                                                type="submit"
                                                defaultValue="Submit Now"
                                                className="fh-btn"
                                            />
                                        </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
};

export default Splash;